const openNewTab = function (url){
  url = '#' + url;

  let newTab = window.open(url, '_blank');
  newTab.focus();
}

export { openNewTab }
